
import { computed, ref } from 'vue';

// icons
import { chevronBackOutline, searchOutline, notificationsOutline,
          logoFacebook, logoInstagram, } from 'ionicons/icons';

// components
import { IonHeader, IonGrid, IonToolbar, IonButtons, IonButton,
        IonBackButton, IonIcon, IonTitle, modalController, } from '@ionic/vue';
import LogoImg from "@/components/LogoImg.vue";
import NotificationListModal from '@/components/templates/NotificationListModal.vue';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  props: [
    "titleOnly",
    "title",
    "parentPath",
    "hideIcons",
    "showSearchIcon",
  ],
  components: { IonHeader, IonGrid, IonToolbar, IonButtons, IonButton,
                IonBackButton, IonIcon, IonTitle, LogoImg },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const userLoggedIn = computed(() => store.state.loggedIn);

    const openNotificationListModal = async () => {
      const modal = await modalController.create({
        component: NotificationListModal,
      });
      return modal.present();
    };
    const onClickSearchBtn = async () => {
      router.push({ name: 'ProductListPage', params: { parentPath: '/home', from: "searchIcon" } }); // go to product page
    }

    return {
      // icons
      searchOutline, notificationsOutline, logoFacebook, logoInstagram,

      // variables
      userLoggedIn,

      // methods
      t, openNotificationListModal, onClickSearchBtn,
    }
  }
}
